import { Box, TextField, styled } from '@mui/material';

export const DropBoxBody = styled(Box)(({ theme }) => ({
  position: 'relative',
  '&[data-drop-placement="before"]:before': {
    top: '-1px',
    left: 0,
    right: 0,
    height: '2px',
    content: '""',
    display: 'block',
    position: 'absolute',
    backgroundColor: theme.palette.primary.main,
  },
  '&[data-drop-placement="after"]:after': {
    left: 0,
    right: 0,
    bottom: '-1px',
    height: '2px',
    content: '""',
    display: 'block',
    position: 'absolute',
    backgroundColor: theme.palette.primary.main,
  },
}));

export const NameTextField = styled(TextField)(({ theme }) => ({
  '.MuiInputBase-input': {
    paddingTop: 0,
    paddingBottom: 0,
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
    minHeight: theme.spacing(3.5),
  },
}));
